module.exports = __webpack_public_path__ + "static/media/ueber-uns.d15f07eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/icons/teaser/ueber-uns.svg
// module id = 914
// module chunks = 0